module.exports = __webpack_public_path__ + "static/media/fwbz3_en.25a63269.png";